import { Button } from "@kvix/ui";
import { Box } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { PlanList } from "./PlanList";

interface Props {
  onCancel: () => void;
  loading: boolean;
  activePlanIds: string[];
  upcomingPlanIds: string[];
}

export const SubscriptionScheduleInformation: React.FC<Props> = (props) => {
  const { t, ready } = useTranslation(["general", "payment"]);

  if (!ready) {
    return null;
  }

  return (
    <Box>
      <Alert
        variant="filled"
        severity="info"
        action={
          <Button
            variant="text"
            color="inherit"
            size="small"
            onClick={props.onCancel}
            loading={props.loading}
          >
            {t("general:buttons.cancel")}
          </Button>
        }
      >
        <Trans
          i18nKey="payment:dialog.editBillingInterval.scheduled"
          components={[
            <PlanList planIds={props.activePlanIds} />,
            <PlanList planIds={props.upcomingPlanIds} />,
          ]}
        />
      </Alert>
    </Box>
  );
};
